import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { UserActionFeatureSystemsComponent } from '../userAction-featureSystem/userAction-featureSystem.component';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { ValidFeatureService } from '../../../../Services/validFeature.service';
import { ValidFeatureSystem } from '../../../../Model/ValidFeatureSystem';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';
import { UserActionBaseComponent } from '../userAction-base.component';

@Component({
    selector: 'userAction-createTechnicalDetails',
    templateUrl: 'userAction-createTechnicalDetails.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionCreateTechnicalDetailsComponent) }
    ],
    standalone: false
})
export class UserActionCreateTechnicalDetailsComponent extends UserActionFeatureSystemsComponent {
  selectedFeatureSystem: ValidFeatureSystem;

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public validFeatureSystem: ValidFeatureService,
    public systemService: SystemService
  ) {
    super(loginService, macroService, catalogService, validFeatureSystem);
  }

  public async canStartMacro() : Promise<boolean>{
    if (!this.selectedFeatureSystem) {
      this.systemService.notifyInfo(this.translate.instant('FeatureSystem auswählen'));
      return false;
    }

    return true;
  }

  createParameterStringAsJsonString() {
    return JSON.stringify(this.selectedFeatureSystem);
  }

  public parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.selectedFeatureSystem = parsed.selectedFeatureSystem;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
